import React from "react"

import {
	Box,
	Typography,
} from "@mui/material"

import {
	SupportCardInfo,
} from "./models"
import { SbCard } from "components/commons/sb-card/sb-card"

export interface SupportCardProps
{
	type: SupportCardInfo,
	title: string,
	text: string
}

export class SupportCard extends React.Component<SupportCardProps, {}>
{
	private isSmallScreen: boolean = window.innerWidth < 1024

	render()
	{
		return (
			<Box mb={2}>
				<SbCard
					avatarIcon={this.props.type.avatarIcon}
					backgroundImage={this.props.type.background}
					avatarBackgroundColour={this.props.type.avatarColour}
					title={this.props.title}
					height="100px">
					<Typography sx={{ color: 'white', fontSize: this.isSmallScreen ? 14 : 16 }}>
						{this.props.text}
					</Typography>
				</SbCard>
			</Box>
		)

		// return (
		// 	<Paper
		// 		elevation={0}
		// 		sx={{
		// 			height: "100px",
		// 			px: 2,
		// 			py: 2,
		// 			mb: 2,
		// 			position: "relative",
		// 			backgroundImage: `url(${this.props.type.background})`,
		// 			backgroundSize: "160% 100%",
		// 			backgroundPosition: "0% 50%",
		// 			cursor: "pointer",
		// 		}}>
		// 		<Stack direction="column" display="flex" justifyContent="space-between" height="100%">
		// 			<Typography sx={{ color: 'white', fontSize: this.isSmallScreen ? 14 : 16 }}>
		// 				{this.props.title}
		// 			</Typography>
		//
		// 			<Typography sx={{ color: 'white', fontSize: this.isSmallScreen ? 14 : 16 }}>
		// 				{this.props.text}
		// 			</Typography>
		// 		</Stack>
		// 		<div style={{
		// 			position: "absolute",
		// 			right: "16px",
		// 			top: "16px",
		// 		}}>
		// 				<Avatar sx={{
		// 					backgroundColor: this.props.type.avatarColour,
		// 					width: 56,
		// 					height: 56,
		// 				}}>
		// 					<SvgIcon component={this.props.type.avatarIcon} sx={{ fontSize: 40 }} />
		// 				</Avatar>
		// 		</div>
		// 	</Paper>
		// )
	}
}
